import PrimaryCell from "../../../../../../ui/Table/Cells/PrimaryCell";

export const columns = [
  {
    dataField: "id",
    caption: "ID",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 80
  },
  {
    dataField: "dateReq",
    caption: "Дата запроса",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 100
  },
  {
    dataField: "typeObject",
    caption: "Тип объекта",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 150
  },
  {
    dataField: "code",
    caption: "Код",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "name",
    caption: "Наименование",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "osnRazrab",
    caption: "Основание разработки",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "owner",
    caption: "Правообладатель",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "state",
    caption: "Статус",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 80
  },
  {
    dataField: "authors",
    caption: "Составители",
    dataType: "string",
    cellRender: PrimaryCell
  }
];
